var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-guide"},[_c('img',{staticClass:"guide-img",attrs:{"src":require("../../public/images/appGuide/guide.png"),"alt":""}})])
}]

export { render, staticRenderFns }